(()=>{
const reduce=window.matchMedia('(prefers-reduced-motion: reduce)').matches;
const FREE_SHIP=5000;

/* Scroll reveals */
if(!reduce&&'IntersectionObserver' in window){
  document.documentElement.classList.add('ab-glow-ready');
  document.querySelectorAll('.ab-product').forEach((el,i)=>el.style.setProperty('--i',i%3));
  const io=new IntersectionObserver(es=>es.forEach(e=>{if(e.isIntersecting){e.target.classList.add('is-in');io.unobserve(e.target)}}),{threshold:.15,rootMargin:'0px 0px -6% 0px'});
  document.querySelectorAll('.ab-product,[data-ab-reveal],.ab-how__step').forEach(el=>io.observe(el));
}else{
  document.querySelectorAll('.ab-how__step').forEach(el=>el.classList.add('is-in'));
}

/* Hero + sets glow follows the pointer */
if(!reduce&&window.matchMedia('(hover: hover)').matches){
  const follow=(el,x,y)=>el.addEventListener('pointermove',e=>{const r=el.getBoundingClientRect();el.style.setProperty(x,((e.clientX-r.left)/r.width*100).toFixed(1)+'%');el.style.setProperty(y,((e.clientY-r.top)/r.height*100).toFixed(1)+'%')});
  document.querySelectorAll('.ab-hero').forEach(el=>follow(el,'--gx','--gy'));
  document.querySelectorAll('.ab-sets').forEach(el=>follow(el,'--sx','--sy'));
}

/* Cart drawer: free-shipping progress bar */
const money=c=>'$'+(c/100).toFixed(2);
let last=null;
const render=()=>{
  const host=document.querySelector('.cart-drawer__summary');
  if(!host||last===null)return;
  let bar=host.querySelector('.ab-ship');
  if(!bar){bar=document.createElement('div');bar.className='ab-ship';bar.setAttribute('role','status');bar.innerHTML='<span class="ab-ship__text"></span><div class="ab-ship__bar"><div class="ab-ship__fill"></div></div>';host.prepend(bar)}
  const left=FREE_SHIP-last,done=left<=0;
  bar.classList.toggle('is-done',done);
  bar.querySelector('.ab-ship__text').textContent=done?'You’ve unlocked free U.S. shipping.':'You’re '+money(left)+' away from free U.S. shipping.';
  requestAnimationFrame(()=>bar.style.setProperty('--p',Math.min(100,last/FREE_SHIP*100)+'%'));
};
const refresh=()=>fetch((window.Shopify&&Shopify.routes?Shopify.routes.root:'/')+'cart.js',{headers:{Accept:'application/json'}}).then(r=>r.json()).then(c=>{last=c.total_price;render()}).catch(()=>{});
document.addEventListener('cart:update',()=>setTimeout(refresh,150));
const nativeFetch=window.fetch;
window.fetch=function(input){const p=nativeFetch.apply(this,arguments);try{const u=typeof input==='string'?input:input.url;if(/\/cart\/(add|change|update|clear)/.test(u))p.then(()=>setTimeout(refresh,100),()=>{})}catch(e){}return p};
refresh();
let queued=false;
new MutationObserver(()=>{if(queued)return;queued=true;requestAnimationFrame(()=>{queued=false;if(!document.querySelector('.cart-drawer__summary .ab-ship'))render()})}).observe(document.body,{childList:true,subtree:true});
})();
